import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt, faTools } from '@fortawesome/free-solid-svg-icons';
import '../../sass/Crashing.scss';
import Logo from '../../images/Logo.png';

const Crashing = () => {
    const [reloading, setReloading] = useState(false);

    return (
        <div className="crashing-container">
            <div className="container-sm">
                <div className="row">
                    <div className="col-md-8">
                        <h1>Oops!!! Ocurrio en error al cargar la página... </h1>
                        <br />
                        <h2>Intente nuevamente recargar...</h2>
                        <br />
                        <br />
                        <button onClick={() => {
                            setReloading(true)
                            window.location.reload(false);
                        }}>
                            {
                                !reloading ?
                                    <h3><FontAwesomeIcon icon={faRedoAlt} />  RECARGAR</h3> :
                                    <h3>
                                        <span class="spinner-border" role="status" aria-hidden="true"></span>  CARGANDO...
                                    </h3>
                            }
                        </button>
                    </div>
                    <div className="col-md-4">
                        <span className="crash-image"><FontAwesomeIcon icon={faTools} /></span>
                    </div>
                </div>
            </div>
            <img id="logo" src={Logo} alt="..." />
        </div>
    )
}

export default Crashing
